import React, { useState, useCallback } from 'react';
import GridContainer from '@ertelecom/ui-react/components/layouts/gridContainer';
import { PaddingWrapper, Title } from './styled';
import PopupResult from '@ertelecom/ui-react/components/popups/popupResult';
import { useSelector } from 'react-redux';
import { PRODUCTS } from '~/src/constants';
import { sendRequestByConnection } from '~/src/api/service-request/request-by-connection';
import { dataLayerForCPA } from '~/src/helpers/eventsForDataLayer';
import { captureException } from '@sentry/node';
import { RequestForm } from '~/src/components/RequestForm';
import { dataLayerPush } from '@ertelecom/ui-react/components/helpers';


const resultType = {
    SUCCESS: 'success',
    ERROR: 'error',
};

const dataLayerOptions = (action, label) => ({ event: 'UAevent', category: 'videocontrol form', action, label });

const RequestSection = ({ bgColor, nonBottomPadding, textColor }) => {
    const city = useSelector(state => state.city.currentCity);
    const [popup, setPopup] = useState({
        isOrderOpened: false,
        isResultOpened: false,
        resultTitle: null,
        resultText: null,
        resultType: resultType.SUCCESS,
    });

    const submitRequest = useCallback(async(params) => {
        params.product_id = PRODUCTS.videocontrol;
        try {
            const resp = await sendRequestByConnection(city.domain, params);
            const successResultCode = [0, 6];
            const action = (successResultCode.includes(resp.billing_code)) ? 'Send' : 'no potential';
            const label = (successResultCode.includes(resp.billing_code)) ? 'no potential' : resp.message;
            if (successResultCode.includes(resp.billing_code)) {
                openPopupResult(true);
            } else {
                openPopupResult(false, resp.message);
            }
            dataLayerPush(dataLayerOptions(action, label));
            dataLayerForCPA(resp);
            window.fbq('track', 'lead_footer');
            window._tmr.push({ id: '3213734', type: 'reachGoal', goal: 'lead_footer' });
        } catch (err) {
            captureException(err);
            openPopupResult(false, 'Не удалось отправить заявку.');
            dataLayerPush(dataLayerOptions('undefined', 'Произошла ошибка. Код не известен.'));
        }
    }, [city]);

    const openPopupResult = useCallback((result, resText = '') => {
        setPopup({
            isResultOpened: true,
            resultType: result ? resultType.SUCCESS : resultType.ERROR,
            resultTitle: result ? 'Заявка на подключение отправлена' : 'Произошла ошибка',
            resultText: result ? 'Мы свяжемся с вами в ближайшее время' : resText,
        });
    }, []);

    const closePopup = useCallback(() => {
        setPopup(state=>({
            ...state,
            isResultOpened: false,
        }));
    }, []);

    return (
        <PaddingWrapper id='request' bgColor={bgColor} nonBottomPadding={nonBottomPadding}>
            <GridContainer>
                <Title data-test='titleQuestions' textColor={textColor}>Оставьте заявку и мы Вам перезвоним</Title>
                <RequestForm
                    isLoading={false}
                    message={null}
                    city={city.domain}
                    submitRequest={submitRequest}
                />
                <PopupResult
                    isOpen={popup.isResultOpened}
                    onClose={closePopup}
                    title={popup.resultTitle}
                    text={popup.resultText}
                    type={popup.resultType}
                />
            </GridContainer>
        </PaddingWrapper>
    );
};

export default RequestSection;
